<template>
  <form>
    <div class="two-column-form-container prochip-form-container">
      <div class="wd-50">
        <div class="text-control">
          <input
            type="text"
            id="firstName"
            class="text-input flex-fill"
            v-model.trim="$v.firstName.$model"
            :class="{'error-text-control': $v.firstName.$errors && $v.firstName.$errors.length > 0}"
            @input="formValueChanged($v.firstName)"
            @blur="$v.firstName.$touch"
            aria-describedby="firstName-error"
            aria-required="true"
            :aria-invalid="$v.firstName.$errors.length > 0"
          />
          <label for="firstName" class="text-label" :class="{'error-label': $v.firstName.$errors && $v.firstName.$errors.length > 0}">First Name</label>
          <span class="required">*</span>
        </div>
        <div class="input-errors" id="firstName-error" aria-live="assertive" aria-relevant="all">
          <div v-for="(error, index) of $v.firstName.$errors" :key="index" class="error-msg">{{ error.$message }}</div>
        </div>
      </div>
      <div class="wd-45">
        <div class="text-control">
          <input
            type="text"
            id="lastName"
            class="text-input flex-fill"
            v-model.trim="$v.lastName.$model"
            :class="{'error-text-control': $v.lastName.$errors && $v.lastName.$errors.length > 0}"
            @input="formValueChanged($v.lastName)"
            @blur="$v.lastName.$touch"
            aria-describedby="lastName-error"
            aria-required="true"
            :aria-invalid="$v.lastName.$errors.length > 0"
          />
          <label for="lastName" class="text-label" :class="{'error-label': $v.lastName.$errors && $v.lastName.$errors.length > 0}">Last Name</label>
          <span class="required">*</span>
        </div>
        <div class="input-errors" id="lastName-error" aria-live="assertive" aria-relevant="all">
          <div class="error-msg" v-for="(error, index) of $v.lastName.$errors" :key="index">{{ error.$message }}</div>
        </div>
      </div>
    </div>
    <div class="two-column-form-container">
      <div class="wd-50">
        <div class="text-control">
          <input
            type="text"
            id="email"
            class="text-input flex-fill"
            v-model.trim="$v.email.$model"
            :class="{'error-text-control': $v.email.$errors && $v.email.$errors.length > 0}"
            @input="formValueChanged($v.email)"
            @blur="$v.email.$touch"
            aria-describedby="email-error"
            aria-required="true"
            :aria-invalid="$v.email.$errors.length > 0"
          />
          <label for="email" class="text-label" :class="{'error-label': $v.email.$errors && $v.email.$errors.length > 0}">Email Address</label>
          <span class="required">*</span>
        </div>
        <div class="input-errors" id="email-error" aria-live="assertive" aria-relevant="all">
          <div class="error-msg" v-for="(error, index) of $v.email.$errors" :key="index">{{ error.$message }}</div>
        </div>
      </div>
      <div class="wd-45">
        <div class="text-control">
          <input
            type="text"
            id="company"
            class="text-input flex-fill"
            :class="{'error-text-control': $v.company.$errors && $v.company.$errors.length > 0}"
            v-model.trim="$v.company.$model"
            @input="formValueChanged($v.company)"
            @blur="$v.company.$touch"
            aria-describedby="company-error"
            aria-required="true"
            :aria-invalid="$v.company.$errors.length > 0"
          />
          <label for="company" class="text-label" :class="{'error-label': $v.company.$errors && $v.company.$errors.length > 0}">Company</label>
          <span class="required">*</span>
        </div>
        <div class="input-errors" id="company-error" aria-live="assertive" aria-relevant="all">
          <div class="error-msg" v-for="(error, index) of $v.company.$errors" :key="index">{{ error.$message }}</div>
        </div>
      </div>
    </div>
    <div class="two-column-form-container">
      <div class="wd-50">
        <div class="text-control">
          <input
            type="text"
            id="phone"
            class="text-input flex-fill"
            v-model.trim="$v.phone.$model"
            :class="{'error-text-control': $v.phone.$errors && $v.phone.$errors.length > 0}"
            @input="formValueChanged($v.phone)"
            @blur="$v.phone.$touch"
            aria-describedby="phone-error"
            aria-required="true"
            :aria-invalid="$v.phone.$errors.length > 0"
          />
          <label for="phone" class="text-label" :class="{'error-label': $v.phone.$errors && $v.phone.$errors.length > 0}">Phone</label>
          <span class="required">*</span>
        </div>
        <div class="input-errors" id="phone-error" aria-live="assertive" aria-relevant="all">
          <div class="error-msg" v-for="(error, index) of $v.phone.$errors" :key="index">{{ error.$message }}</div>
        </div>
      </div>
      <div class="wd-45">
        <div class="text-control textbox-wd98">
          <input
            type="text"
            id="address"
            class="text-input flex-fill"
            v-model.trim="$v.address.$model"
            @input="formValueChanged($v.address)"
            @blur="$v.address.$touch"
          />
          <label for="address" class="text-label">Address</label>
        </div>
      </div>
    </div>
    <div class="two-column-form-container">
      <div class="wd-50">
        <div class="text-control textbox-wd98">
          <input
            type="text"
            id="city"
            class="text-input flex-fill"
            :class="{'error-text-control': $v.city.$errors && $v.city.$errors.length > 0}"
            v-model.trim="$v.city.$model"
            @input="formValueChanged($v.city)"
            @blur="$v.city.$touch"
            aria-describedby="city-error"
            :aria-invalid="$v.city.$errors.length > 0"
          />
          <label for="city" class="text-label" :class="{'error-label': $v.city.$errors && $v.city.$errors.length > 0}">City</label>
        </div>
        <div class="input-errors" id="city-error" aria-live="assertive" aria-relevant="all">
          <div class="error-msg" v-for="(error, index) of $v.city.$errors" :key="index">{{ error.$message }}</div>
        </div>
      </div>
      <div class="wd-45">
        <div class="text-control textbox-wd98">
          <input
            type="text"
            id="postalCode"
            class="text-input flex-fill"
            v-model.trim="$v.postalCode.$model"
            @input="formValueChanged($v.postalCode)"
            @blur="$v.postalCode.$touch"
          />
          <label for="postalCode" class="text-label">Postal code</label>
        </div>
      </div>
    </div>
    <div class="two-column-form-container">
      <div class="wd-50">
        <div class="text-control textbox-wd98">
          <input
            type="text"
            id="country"
            class="text-input flex-fill"
            :class="{'error-text-control': $v.country.$errors && $v.country.$errors.length > 0}"
            v-model.trim="$v.country.$model"
            @input="formValueChanged($v.country)"
            @blur="$v.country.$touch"
            aria-describedby="country-error"
            :aria-invalid="$v.country.$errors.length > 0"
          />
          <label for="country" class="text-label" :class="{'error-label': $v.country.$errors && $v.country.$errors.length > 0}">Country</label>
        </div>
        <div class="input-errors" id="country-error" aria-live="assertive" aria-relevant="all">
          <div class="error-msg" v-for="(error, index) of $v.country.$errors" :key="index">{{ error.$message }}</div>
        </div>
      </div>
      <div class="wd-45">
        <div class="text-control textbox-wd98">
          <input
            type="text"
            id="state"
            class="text-input flex-fill"
            :class="{'error-text-control': $v.state.$errors && $v.state.$errors.length > 0}"
            v-model.trim="$v.state.$model"
            @input="formValueChanged($v.state)"
            @blur="$v.state.$touch"
            aria-describedby="state-error"
            :aria-invalid="$v.state.$errors.length > 0"
          />
          <label for="state" class="text-label" :class="{'error-label': $v.state.$errors && $v.state.$errors.length > 0}">State</label>
        </div>
        <div class="input-errors" id="state-error" aria-live="assertive" aria-relevant="all">
          <div class="error-msg" v-for="(error, index) of $v.state.$errors" :key="index">{{ error.$message }}</div>
        </div>
      </div>
    </div>
  </form>  
</template>
<script>
import {reactive} from 'vue';
import {useVuelidate} from '@vuelidate/core';
import {email, minLength, maxLength} from '@vuelidate/validators';

export function isFilled(word) {
  if (word){
    return true;
  }
  return false;
}

export function onlyAlphabets(word) {
  let validAlphabetPattern = new RegExp("^([\\sa-zA-Z])*$");
  if (validAlphabetPattern.test(word)){
    return true;
  }
  return false;
}

export function validPhone(phone) {
  let validPhonePattern = new RegExp("^(0|\\+[1-9]{1,2}[\\s]?)?(([1-9]{1}[0-9]{9}([0-9]{1})?)|(\\([1-9]{1}[0-9]{2}\\)[\\s]?[0-9]{3}[\\s-]?[0-9]{4})|([1-9]{1}[0-9]{2}[.-\\s]?[0-9]{3}[.-\\s][0-9]{4}))$");
  if (validPhonePattern.test(phone)){
    return true;
  }
  return false;
}

export default {
  emits: ['userDataChanged'],
  setup (props, context) {
    const form = reactive({
      firstName: "",
      lastName: "",
      email: "",
      name: "",
      company: "",
      phone: "",
      fax: "",
      address: "",
      city: "",
      postalCode: "",
      country: "",
      state: "",
    });
    const rules = {
      firstName: {
        required: {
          $validator: isFilled,
          $message: 'Please fill in the first name.'
        },
        alphabet_validation: {
          $validator: onlyAlphabets,
          $message: 'Should contain only letters and spaces.'
        }
      },
      lastName: { 
        required: {
          $validator: isFilled,
          $message: 'Please fill in the last name.'
        },
        alphabet_validation: {
          $validator: onlyAlphabets,
          $message: 'Should contain only letters and spaces.'
        }
      },
      email: { 
        required: {
          $validator: isFilled,
          $message: 'Please fill in the email.'
        },
        email
      },
      company: { 
        required: {
          $validator: isFilled,
          $message: 'Please fill in the company.'
        },
        alphabet_validation: {
          $validator: onlyAlphabets,
          $message: 'Should contain only letters and spaces.'
        }
      },
      phone: { 
        required: {
          $validator: isFilled,
          $message: 'Please fill in the phone.'
        },
        minLength: minLength(10), maxLength: maxLength(18),
        phone_validation: {
          $validator: validPhone,
          $message: 'Invalid phone number format.',
        }
      },
      address:{},
      city: { 
        alphabet_validation: {
          $validator: onlyAlphabets,
          $message: 'Should contain only letters and spaces.'
        }
      },
      postalCode:{},
      country: { 
        alphabet_validation: {
          $validator: onlyAlphabets,
          $message: 'Should contain only letters and spaces.'
        }
      },
      state: { 
        alphabet_validation: {
          $validator: onlyAlphabets,
          $message: 'Should contain only letters and spaces.'
        }
      },
    };

    const $v = useVuelidate(rules, form);
    function formValueChanged(ref) {
      ref.$touch;
      context.emit('userDataChanged', {
        firstName: form.firstName,
        lastName: form.lastName,
        email: form.email,
        name: form.name,
        company: form.company,
        phone: form.phone,
        fax: form.fax,
        address: form.address,
        city: form.city,
        postalCode: form.postalCode,
        country: form.country,
        state: form.state,
        isFormInvalid: $v._value.$errors.length > 0 || $v._value.$silentErrors.length > 0,
      });
    }
    return { 
      form,
      $v,
      formValueChanged,
     };
  }
};
</script>

<style scoped>
.textbox-wd98{
  width:98%;
}
</style>